import React from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import './Login.css'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'

import { loginCustomer } from '../../redux/CustomerReducer'
const Login = () => {
    const dispatch=useDispatch();
    const navigate=useNavigate();

        const[user,setUser]=useState(
            {
                email:"",
                password:""
            }
        )

        const handleChange=(e)=>{

            const{name,value}=e.target

            setUser(
                {
                    ...user,[name]:value
                }
            )
        }

        const loginClicked=async()=>{
            console.log("Clicked")

        const response=await   dispatch(loginCustomer(user))

     console.log("Loginresponse",response)

        if(response?.payload?.status===true)
        {
            Swal.fire(
                'Good',
                response?.payload?.message,
                'success'
              )

            navigate("/")
        }
        if(response.payload.data.status===false)
        {
            Swal.fire(
                'Error',
                response.payload.data.message,
                'Error'
              )

      
        }
        

        }



  return (
    <>
    <div className='mainContainerLogin'>
        <div className='userLoginTxt'>
            Customer Login

        </div>

        <div className='topInputFieldLogin'>
            <div className='inputTxtLogin'>Email</div>
            <input className='inputLogins' type="email"
            
            onChange={handleChange}
            name="email"
            placeholder='Enter Email'/>
        </div>
        <div className='topInputFieldLogin'>
            <div className='inputTxtLogin'>Password</div>
            <input className='inputLogins'
            
            onChange={handleChange}
            name="password"
            type="password" placeholder='Enter Password'/>
        </div>
        <div className='forgotPassTxt'>
            Forgot password?
        </div>

        <button className='loginBtn' 
        onClick={()=>loginClicked()}

    
        >
            Login
        </button>

        <div className='ntMemberTxt'>
            Not a member? 
        <Link to="/customer/register">    <span className='spCreatAccnt'>Create Account</span></Link>
        </div>

    </div>
    
    
    </>
  )
}

export default Login